import React from 'react';
import { SortConfig } from '../../hooks/useSort';

interface SortIconProps<T> {
  field: keyof T;
  sortConfig: SortConfig<T>;
}

/**
 * Componente icona per visualizzare lo stato di ordinamento
 */
export const SortIcon = <T,>({ field, sortConfig }: SortIconProps<T>): React.ReactElement => {
  if (sortConfig.field !== field) {
    return <span className="sort-icon" aria-label="Ordinabile">⇅</span>;
  }
  
  return (
    <span 
      className="sort-icon active" 
      aria-label={`Ordinato ${sortConfig.direction === 'asc' ? 'crescente' : 'decrescente'}`}
    >
      {sortConfig.direction === 'asc' ? '↑' : '↓'}
    </span>
  );
};

export default SortIcon;